import { apiCall } from '../utils/api';

/**
 * Service für Meldungen (Sessions, Profile) — Anti-Mobbing/Missbrauch
 */
const ModerationService = {
  /**
   * Meldet eine Session oder ein Profil
   * @param {Object} params
   * @param {'SESSION'|'PROFILE'} params.targetType
   * @param {string} params.targetId - Session-ID bzw. Profil-ID
   * @param {string} params.reportedUserId - User-ID des Gemeldeten (Host bzw. Profil-Inhaber)
   * @param {string} params.reason - BELEIDIGUNG | MOBBING | SPAM | UNANGEMESSEN | SONSTIGES
   * @param {string} [params.details] - Freitext (max 500 Zeichen)
   */
  reportContent: async ({ targetType, targetId, reportedUserId, reason, details = '' }) => {
    return apiCall('/api/v1/moderation/reports', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        targetType, targetId, reportedUserId, reason, details,
      }),
    });
  },
};

export default ModerationService;
